import React, {useCallback, useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from "../../contexts/ModalContext";
import TitleSecondary from "../../components/Title/TitleSecondary";
import {useUser} from "../../contexts/UserContext";
import {
    getStatsMainPage, getStatsTabActiviteTypesPage, getStatsTabSeancesPage,
} from "../../services/StatsService";
import SeancesStatsTable from "../../components/Seance/SeancesStatsTable";
import styles from "./Statistiques.module.css";
import UsersStatsTable from "../../components/Seance/UsersStatsTable";
import {exportToCsv} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faExternalLink, faFilter} from "@fortawesome/free-solid-svg-icons";
import FilterHamburgerCustom from "../../components/Filter/FilterHamburgerCustom";
import ActiviteTypesStatsTable from "../../components/ActiviteType/ActiviteTypesStatsTable";
import SearchEntreprise from "../../components/Search/SearchEntreprise";
import {updateFilterUri} from "../../services/FilterService";
import styles_filter from "../../components/Filter/Filter.module.css";
import {ReactComponent as AnnulerIcon} from "../../icons/annuler.svg";
import styles_field from "../../components/Field/Field.module.css";
import AxiosConfig from "../../services/AxiosConfig";
import Routing from "../../services/routing";
import {SelectFilter} from "../../components/Filter/SelectFilter";
import {DatesFilter} from "../../components/Filter/DatesFilter";
import DateService from "../../services/DateService";

function TabActiviteTypesStatsPage() {
    const { user } = useUser();
    const { showModal } = useModal();
    const [data, setData] = useState([]);
    const [activiteTypes, setActiviteTypes] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [filterDateDebut, setFilterDateDebut] = useState(params.get('filter_date') ? params.get('filter_date').split(',')[0] : '');
    const [filterDateFin, setFilterDateFin] = useState(params.get('filter_date') ? params.get('filter_date').split(',')[1] : '');
    // Par défaut dateDebut est il y a 3 mois et dateFin est aujourd'hui
    // const now = new Date();
    // const [filterDateDebut, setFilterDateDebut] = useState(new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()).toISOString().split('T')[0]);
    // const [filterDateFin, setFilterDateFin] = useState(now.toISOString().split('T')[0]);
    let filterDates = "";

    const handleSuccess = useCallback((message = "Statistiques récupérées") => {
        showModal('success', { children: message, timeout: 1500 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 1500 });
    }, [showModal]);

    const handleDateDebutChange = (event) => {
        setFilterDateDebut(event.target.value);
    };

    const handleDateFinChange = (event) => {
        setFilterDateFin(event.target.value);
    };

    const applyDateConfirmationFilter = (startDate, endDate) => {
        setFilterDateDebut(startDate);
        setFilterDateFin(endDate);

        const value = `${startDate},${endDate}`;

        updateFilter('filter_date', value, true);
    };


    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const handleSeanceSelectChange = (event) => {
        const selectedValue = event.target.value;
        updateFilter('filter_seance', selectedValue, true);
    };

    const handleActiviteTypeSelectChange = (event) => {
        const selectedValue = event.target.value;
        updateFilter('filter_type', selectedValue, true);
    };

    const seancesFilterOptions = [
        { label: "Toutes", value: "toutes" },
        { label: "Disponibles à inscriptions", value: "dispo" },
        { label: "Passées", value: "passees" },
    ];

    const filterChildren = (
        <div>
            <TitleSecondary text={"Filtres"}/>
            <div className={styles_filter.filtersRemoveBar}>
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        let strValue = value;
                        if (key === "filter_type") {
                            strValue = activiteTypes.find(at => parseInt(at.value) === parseInt(value))?.label;
                        }

                        if (key === "filter_date") {
                            const date1 = value.split(',')[0];
                            const date2 = value.split(',')[1];
                            strValue = ` ${DateService.formatFrenchDateWithoutTime(date1)} au ${DateService.formatFrenchDateWithoutTime(date2)}`;
                            filterDates = strValue;
                        }

                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcon/>
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {strValue}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                {user.roles.includes("ROLE_ADMIN") && <div>
                    <p>Entreprise</p>
                    <SearchEntreprise onSubmit={(entr) => {
                        updateFilter('filter_entrepriseId', entr.entrepriseId, true);
                    }}/>
                </div>}

                <SelectFilter label={"Type d'activité"} selectId={"selectTypeActivite"} options={activiteTypes} onChangeSelect={handleActiviteTypeSelectChange} defaultValue={parseInt(params.get("filter_type"))}/>
                <SelectFilter label={"Séances"} selectId={"seanceFilter"} options={seancesFilterOptions} onChangeSelect={handleSeanceSelectChange} defaultValue={params.get("filter_seance")}/>
                <DatesFilter startValue={filterDateDebut} endValue={filterDateFin} onChange={applyDateConfirmationFilter}/>
            </div>
        </div>
    );

    const fetchData = async () => {
        const queryParams = location.search;

        const rez = await getStatsTabActiviteTypesPage(queryParams);
        if (rez.success === true || rez.success === "true") {
            if (rez.data) {
                setData(rez.data);
            } else {
                handleError("Pas de données pour les activités");
            }
        } else {
            handleError(rez.message);
        }
    }

    const fetchActiviteTypes = async () => {
        try {
            const response = await AxiosConfig.get("/activites/types");

            const rez = response.data;

            if (rez.success === true || rez.success === "true") {
                if (rez.types) {
                    setActiviteTypes(rez.types);
                } else {
                    handleError("Pas de données pour les activités");
                }
            } else {
                handleError(rez.message);
            }
        } catch (error) {
            console.error('error: ', error);
            throw error;
        }
    }

    useEffect(() => {
        if (!user) return;
        fetchData();
        fetchActiviteTypes();
    }, [user, location.search]);

    const dateDefaultTabSeancesStart = new Date();
    dateDefaultTabSeancesStart.setMonth(dateDefaultTabSeancesStart.getMonth() - 1);
    const dateDefaultTabSeancesEnd = new Date();
    const defaultDate = `${dateDefaultTabSeancesStart.toISOString().split('T')[0]},${dateDefaultTabSeancesEnd.toISOString().split('T')[0]}`;

    return (
        <div className="content_tab">
            <TitleMain text={"Statistiques des Activités"}/>

            <Link style={{ margin: "20px"}} to={
                Routing.generate({
                    route: Routing.routes.statsSeances,
                    queryParams: {filter_date: defaultDate}
                })}>Statistiques des séances <FontAwesomeIcon icon={faExternalLink}/></Link>

            <div className={styles.mobileMessage}>
                Pour une meilleure expérience, veuillez consulter ce tableau sur un ordinateur de bureau ou un écran
                plus
                grand.
            </div>

            <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)}
                                   children={filterChildren}/>


            <div className={styles.tableau}>
                { filterDates &&
                    <span style={{
                        fontSize: "14px",
                        color: "#3c3c3c",
                        fontStyle: "italic",
                    }}>Données du { filterDates }</span>
                }

                <ActiviteTypesStatsTable activiteTypes={data}/>
            </div>

        </div>
    )
}

export default TabActiviteTypesStatsPage;
